import type { PreviewSource } from '../data/contracts';

/**
 * Version « en usage » d'un dossier : la plus récente des versions acceptées du Module Spec (null s'il n'y en a aucune).
 * Partagée par « Nouvelle simulation », « Essayer le module », « Actualiser depuis le modèle » et le lien profond du Concepteur.
 */
export const versionInUse = (versions: readonly { version: number; status: string }[]): number | null => {
  const accepted = versions.filter((entry) => entry.status === 'accepted').map((entry) => entry.version);
  return accepted.length > 0 ? Math.max(...accepted) : null;
};

/** Version en usage plus récente que celle d'où la simulation a été tirée (null sinon, et toujours null pour un brouillon). */
export const newerVersionInUse = (source: PreviewSource, inUse: number | null): number | null =>
  source.kind === 'version' && inUse !== null && source.version !== null && inUse > source.version ? inUse : null;

/** Clé d'option de `usePreviewSources` pour une version. */
export const versionSourceKey = (version: number): string => `v${version}`;
